import React from 'react'
import { icon } from '../../../services/icon'
import Link from '../link/Link'

const EmailAddress = ({ block }) => {
    return (
        <div className="baseocom-mb-4">
            {block?.content && (
                <div className="baseocom-block-item">
                    {icon('email')}
                    <Link isIcon={false} url={block?.attributes?.href}>
                        {block?.content}
                    </Link>
                </div>
            )}
        </div>
    )
}

export default EmailAddress
